export default __webpack_public_path__ + "static/media/yellowbulb.cfe1cea8.jpeg";